module.exports = __webpack_public_path__ + "img/th.dfe9e8d7.svg";